import type { ChatMessage } from "@school-sales-ai/shared";

// Public chat endpoints (keyed by sessionRef) — the SAME real prod flow the
// widget uses. Session CREATION is authed (see useTestSessions); message send,
// streaming and history reuse these public endpoints so "Probar Agente"
// exercises production behavior end-to-end.

const BASE_URL = import.meta.env.VITE_API_BASE_URL as string;

async function post<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`POST ${path} failed: ${res.status}`);
  return res.json() as Promise<T>;
}

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`);
  if (!res.ok) throw new Error(`GET ${path} failed: ${res.status}`);
  return res.json() as Promise<T>;
}

export function sendChatMessage(
  sessionRef: string,
  content: string,
): Promise<{ messageId: string }> {
  return post<{ messageId: string }>("/chat/message", { sessionRef, content });
}

export function openChatStream(sessionRef: string): EventSource {
  return new EventSource(
    `${BASE_URL}/chat/stream?sessionRef=${encodeURIComponent(sessionRef)}`,
  );
}

export async function getChatHistory(
  sessionRef: string,
): Promise<{ messages: ChatMessage[]; score: number; greeting: string | null }> {
  type RawMessage = { id: string; role: string; content: string };
  const raw = await get<{
    messages: RawMessage[];
    score: number;
    greeting: string | null;
  }>(`/chat/history?sessionRef=${encodeURIComponent(sessionRef)}`);
  const messages = raw.messages
    .filter((m) => m.role === "user" || m.role === "assistant")
    .map((m) => ({
      id: m.id,
      role: m.role as "user" | "assistant",
      content: m.content,
    }));
  return { messages, score: raw.score, greeting: raw.greeting };
}
